module.exports = __webpack_public_path__ + "img/treetech.f4d0457d.png";